import { Icons } from "assets";
import classNames from "classnames";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import CustomButton from "shared/components/common/customButton";
import CustomSelect from "shared/components/common/customSelect";
import CustomTextArea from "shared/components/common/customTextArea";
import { toastMessage } from "shared/components/common/toast";
import { EditQuestionService } from "shared/services/questionnaire";
import { EditQuestionVS } from "shared/utils/validation";
import styles from "./style.module.scss";

const initialValues: QuestionType = {
  text: "",
  question: null,
};

interface ModifyQuestionsProps {
  data: any;
}

const ModifyQuestions = ({ data }: ModifyQuestionsProps) => {
  const [questions, setQuesitons] = useState<any>([]);
  const [isQuestionEdit, setIsQuestionEdit] = useState<boolean>(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: EditQuestionVS,
    onSubmit: () => {
      handleEditQuestion();
    },
  });

  const {
    values,
    touched,
    errors,
    isSubmitting,
    setFieldValue,
    handleSubmit,
    handleChange,
    setSubmitting,
  } = formik;

  const handleQuestionnaire = () => {
    let tempArr = [];
    for (let i = 0; i < data?.questions?.length; i++) {
      let question = data?.questions[i];

      if (i === 0) {
        setFieldValue("text", question?.text);
        setFieldValue("question", {
          title: String(question?.q_no).padStart(2, "0"),
          value: question?.id,
        });
      }
      let obj = {
        title: String(question?.q_no).padStart(2, "0"),
        value: question?.id,
        action: () => {
          setFieldValue("text", question?.text);
          setFieldValue("question", {
            title: String(question?.q_no).padStart(2, "0"),
            value: question?.id,
          });
        },
      };
      tempArr.push(obj);
    }
    setQuesitons(tempArr);
  };

  const handleEditQuestion = () => {
    setSubmitting(true);
    EditQuestionService({ text: values.text }, values.question.value)
      .then(() => {
        toastMessage("success", "Question updated successfully");
        setIsQuestionEdit(false);
      })
      .catch((err) => {
        toastMessage("error", err?.response?.data?.error);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  useEffect(() => {
    if (data) {
      handleQuestionnaire();
    }
    // eslint-disable-next-line
  }, [data]);

  return (
    <div className={classNames("flex flex-col gap-3")}>
      <div
        className={classNames("flex flex-col sm:flex-row items-start gap-6")}
      >
        <div className={classNames("w-full sm:w-2/6")}>
          <CustomSelect
            label="Question #"
            placeholder="Select Question"
            options={questions}
            value={values.question?.title}
            //@ts-ignore
            error={touched.question && errors?.question ? errors?.question : ""}
            disabled={isSubmitting}
          />
        </div>
        <div className={classNames("w-full sm:w-4/6 relative")}>
          <CustomTextArea
            label="Statement"
            placeholder="Enter Definition"
            required
            value={values.text}
            customInputContainer={classNames(styles.textAreaContainer)}
            onChange={handleChange("text")}
            disabled={!isQuestionEdit || isSubmitting}
            error={
              touched.text &&
              //@ts-ignore
              errors?.text
                ? errors?.text
                : ""
            }
          />
          <div
            className={classNames(styles.editContainer)}
            onClick={() => {
              setIsQuestionEdit(!isQuestionEdit);
            }}
          >
            <Icons.Pencil />
            <label>Edit</label>
          </div>
        </div>
      </div>
      <CustomButton
        title="Save Changes"
        containerStyle={classNames("self-end")}
        onClick={() => {
          handleSubmit();
        }}
        loading={isSubmitting}
        disabled={isSubmitting}
      />
    </div>
  );
};

export default ModifyQuestions;
